class OrderedList {
	constructor(container, orderBy, rowElem, dragElem) {
		this._index = 0;
		this._items = [];
		this._ids = [];
		this._tops = [];

		this._container = container || UI.div('norm');
		this._orderBy = orderBy || 'orderBy';
		this._rowElem = rowElem || 'rowElem';
		this._dragElem = dragElem || 'dragElem';
		this._useIds;

		this._shifting = false;
		this._activeRow = null;
		this._callback = null;
		this._stacked = false;

		this._lastHeight = null;
		this._updateTicker = null;

		onEv(document.body, 'List3Update', this.layout.bind(this));
	}

	get container() {return this._container;}
	
	get length() { return this._items.length; }

	get items() {
		return this._items;
	}

	get position() {
		return this._index + 1;
	}

	get item() {
		return this._index === -1 ? false : this._items[this._index];
	}

	get first() {
		return this.length === 0 ? false : this._items[0];
	}

	get last() {
		return this.length === 0 ? false : this._items[this.length - 1];
	}

	get hasPrev() {
		return 0 < this._index;
	}

	get prev() {
		return this.hasPrev ? this._items[this._index - 1] : false;
	}

	get hasNext() {
		return this._index < this.length - 1;
	}

	get next() {
		return this.hasNext ? this._items[this._index + 1] : false;
	}

	set stacked(value) {
		this._stacked = value;
		this.update();
	}
	
	addItem(item) {
		let i = this._items.length;
		if (i === 0) {
			this._useIds = typeof item.id !== 'undefined';
			if (this._orderBy && typeof item[this._orderBy] !== 'number') this._orderBy = false;
			if (this._rowElem && typeof item[this._rowElem] !== 'object') this._rowElem = false;
			if (this._dragElem && typeof item[this._dragElem] !== 'object') this._dragElem = false;
		}
		if (this._orderBy) {
			while (0 < i && item[this._orderBy] < this._items[i-1][this._orderBy]) i--;
		}
		if (this._useIds) this._ids.splice(i, 0, item.id);
		this._items.splice(i, 0, item);
		if (this._rowElem) {
			this._container.appendChild(item[this._rowElem]);
			this.update();
		}
	}
	mapTops(start, end) {
		if (!this._rowElem) return;

		if (typeof start === 'undefined') start = 0;
		if (typeof end === 'undefined') end = this._items.length-1;
		for (let i = start; i <= end; i++) {
			this._tops[i] = this._stacked ? 0 : (i === 0 ? 0 : this._tops[i-1] + this._items[i-1][this._rowElem].offsetHeight);
		}
	}
	setTops(start, end) {
		if (!this._rowElem) return;

		if (typeof start === 'undefined') start = 0;
		if (typeof end === 'undefined') end = this._items.length-1;
		for (let i = start; i <= end; i++) {
			this._items[i][this._rowElem].style.top = this._stacked ? 0 : this._tops[i] + 'px';
		}
	}

	sizeContainer() {
		if (!this._rowElem) return;

		let i = this._items.length;
		if (i == 0) {
			this._container.style.height = '0px';
			return 0;
		}
		let startHight = this._container.offsetHeight;
		let newHeight = this._tops[i-1] + this._items[i-1][this._rowElem].offsetHeight;
		this._container.style.height = newHeight + 'px';
		return newHeight - startHight;
	}

	update() {
		this.layout();

		if (this._updateTicker != null) return;

		this._keepTicking = 10;
		this._updateTicker = setInterval(() => {
			document.body.dispatchEvent(new Event('List3Update'));
		}, 30);
	}

	layout() {
		this.mapTops();
		this.setTops();
		let change = this.sizeContainer();

		if (this._updateTicker != null && !change) {
			this._keepTicking--;
			if (this._keepTicking <= 0) {
				clearInterval(this._updateTicker);
				this._updateTicker = null;
			}
		}
	}

	reset() {
		this._index = -1;
		return this._items.length > 0;
	}

	seek(i) {
		if (i < 0 || i >= this._items.length) return false;
		this._index = i;
		return this._items[i];
	}

	gotoId(id) {
		this._index = this._ids.indexOf(id);
		return this;
	}

	moveFirst() {
		return this.reset() && this.moveNext();
	}

	moveNext() {
		if (this.hasNext) return this._items[++this._index];
		return false;
	}
	
	forEach(func) {
		this._items.forEach(i => func(i));
	}

	getIndex(item) {
		if (typeof (item) === 'object') {
			return this._items.indexOf(item);
		} else {
			return -1;
		}
	}

	removeItem(obj) {
		let i = typeof obj === 'undefined' ? this._index : this._items.indexOf(obj);
		if (i === -1) return false;
		if (this._container) this._items[i][this._rowElem].remove();
		if (this._useIds) this._ids.splice(i, 1);
		this._items.splice(i, 1);
		this.update();
		return obj;
	}

	clear() {
		this._index = 0;
		this._items = [];
		this._tops = [];
		this._container.innerHTML = '';
		this._shifting = false;
		this.update();
	}

	prepDrag(row, ev) {
		if (this._dragElem === null || this._rowElem === null) return;
		this._activeRow = row;
		this._index = this._items.indexOf(row);
		if (this._index === -1) return;
		startDrag(ev, this);
		this.curInElem = pointInElem(row[this._rowElem]);
		row[this._rowElem].style.height = row[this._rowElem].offsetHeight + 'px';
		row[this._dragElem].style.width = row[this._dragElem].offsetWidth + 'px';
		state(this._container, 'drag');
		state(row[this._dragElem], 'drag');
		document.body.appendChild(row[this._dragElem]);
		this.positionDragElem();
	}

	drag() {
		this.positionDragElem();

		if (this._shifting) return;
		var i = this._items.indexOf(this._activeRow);
		var pnt = pointInElem(this._container);
		if (0 < this._index && pnt.y < this.upperTrigger) {
			this.moveUp();
		} 
		if (this._index < this._items.length-1 && this.lowerTrigger < pnt.y) {
			this.moveDn();
		}
	}
	get upperTrigger() {
		return this._tops[this._index-1] + 
			(this._items[this._index-1][this._rowElem].offsetHeight * 0.8);
	}
	get lowerTrigger() {
		return this._tops[this._index+1] + 
			(this._items[this._index+1][this._rowElem].offsetHeight * 0.2);
	}
	
	positionDragElem() {
		this._activeRow[this._dragElem].style.left = pointB.x - this.curInElem.x + 'px';
		this._activeRow[this._dragElem].style.top = pointB.y - this.curInElem.y + 'px';
	}

	reattach() {
		state(this._container, 'norm');
		state(this._activeRow[this._dragElem], 'norm');
		this._activeRow[this._rowElem].appendChild(this._activeRow[this._dragElem]);
		this._activeRow[this._rowElem].style.height = 'auto';
		this._activeRow[this._dragElem].style.left = '0px';
		this._activeRow[this._dragElem].style.top = '0px';
		this._activeRow[this._dragElem].style.width = null;
	}

	clicked(ev) {
		this.reattach();
		if (this._activeRow.clicked) this._activeRow.clicked(ev);
	}

	dropped(ev) {
		this.reattach();
		this.reOrder();
		if (this._activeRow.dropped) this._activeRow.dropped(ev);
	}

	moveUp() {
		if (this._index <= 0) return;
		this._shifting = 1;

		if (this._useIds) this._ids.splice(this._index-1, 0, this._ids.splice(this._index, 1)[0]);
		this._items.splice(this._index-1, 0, this._items.splice(this._index, 1)[0]);

		this.mapTops(this._index-1, this._index);
		this.setTops(this._index-1, this._index--);

		this._shifting = 0;
	}

	moveDn() {
		if (this._items.length-1 <= this._index) return;
		this._shifting = 1;

		if (this._useIds) this._ids.splice(this._index+1, 0, this._ids.splice(this._index, 1)[0]);
		this._items.splice(this._index+1, 0, this._items.splice(this._index, 1)[0]);

		this.mapTops(this._index, this._index+1);
		this.setTops(this._index, ++this._index);

		this._shifting = 0;
	}

	reOrder() {
		for (var i = 0; i < this._items.length; i++) {
			this._items[i].orderBy = i + 1;
		}
	}

	sort() {
		if (this.moveFirst()) do {
			while (this.item.orderBy < this.position) {
				this.moveUp();
			}
		} while (this.moveNext());
	}

	showSaving() {
		state(this._container, 'loading');
	}

	hideSaving() {
		state(this._container, 'norm');
	}
}